import Alpine from "alpinejs";

const newWindowLinks = () => {
	return {
		init() {
			this.$nextTick(() => {
				const links = this.$root.querySelectorAll("a");
				links.forEach((link: HTMLLinkElement) => {
					link.setAttribute("target", "_blank");
				});
			});
		},
	};
};

Alpine.data("newWindowLinks", newWindowLinks);
